import React, { useEffect } from 'react';

function ShowStagesPerformance(props) {
    const [stagesAnalysis, setStagesAnalysis] = React.useState({});
    
    useEffect(() => {
        // count the number of instances of points earned in each stage
        const analysis = {};
        props.stagesPts.forEach((pts, index) => {
            if (!analysis[pts]) {
                analysis[pts] = 0;
            }
            analysis[pts]++;
        });
        setStagesAnalysis(analysis);
    }, [props.stagesPts]);
    // This component will show the performance of the player in each stage when hovering over the stages played in the ranking table
    // You can customize this component to show the desired information, such as a list of stages with their results (win/loss/perfect)
    return (
        <div>
            <p>Stages Played: {props.stagesPts.length}</p>
            {Object.entries(stagesAnalysis).map(([pts, count]) => (
                <p key={pts}>Stage with {pts} pts: {count}</p>
            ))}
        </div>
    );
}

export default ShowStagesPerformance;